import React from 'react';
import {observer} from 'mobx-react';
import { Card, Row, Col } from 'antd';
import { StatisticsCard } from "../../components";
import { Chart, Geom, Axis, Tooltip, Coord, Guide, Label } from 'bizcharts';
import DataSet from "@antv/data-set";
import store from './store';

@observer
class HomeIndex extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      failure: 0
    };
    this.data = [
      {classes: 'P22', count: 81},
      {classes: 'L44', count: 50},
      {classes: 'L43', count: 67},
    ];
    this.cols = {
      region: {alias: '班级'},
      count: {alias: '人数'}
    };
    this.data2 = [
      {item: '百度搜索', count: 5},
      {item: '朋友推荐', count: 21},
      {item: '微信文章', count: 10},
      {item: '知乎文章', count: 10},
      {item: '51CTO文章', count: 5},
    ];
    this.dv = new DataSet.DataView();
    this.dv.source(this.data2).transform({
      type: "percent",
      field: "count",
      dimension: "item",
      as: "percent"
    });
    this.cols2 = {
      percent: {
        formatter: val => {
          val = (val * 100).toFixed(0) + "%";
          return val;
        }
      }
    };

  }

  // componentDidMount() {
    // store.fetchInfo()
  // }

  render() {
    const data = [
      {
        year: "2019-06",
        人数: 53
      },
      {
        year: "2019-07",
        人数: 51
      },
     {
        year: "2019-08",
        人数: 38
      },
      {
        year: "2019-09",
        人数: 51
      },{
        year: "2019-10",
        人数: 60
      },
      {
        year: "2019-11",
        人数: 55
      },
      {
        year: "2019-12",
        人数: 35
      },
      {
        year: "2020-01",
        人数: 30
      },
      {
        year: "2020-01",
        人数: 20
      },{
        year: "2020-02",
        人数: 19
      }
    ];
    const cols = {
      value: {
        min: 0
      },
      year: {
        range: [0, 1]
      }
    };
    return (
        <React.Fragment>
          <StatisticsCard loading={store.isFetching}>
            <StatisticsCard.Item title="学员总数" value={100}/>
            <StatisticsCard.Item title="班级数量" value={32}/>
            <StatisticsCard.Item title="在校学员" value={<span style={{color: 'green'}}>99</span>}/>
            <StatisticsCard.Item
                title="特殊学员"
                bordered={false}
                value={<span style={{color: 'red'}}>1</span>}/>
                {/*value={<span style={{color: 'red'}}>{store.info.failure}</span>}/>*/}
          </StatisticsCard>
          <div>
            <Card title="学员报名趋势">
              <Chart height={400} data={data} scale={cols} forceFit>
                <Axis name="year" />
                <Axis name="人数" />
                <Tooltip
                    crosshairs={{
                      type: "y"
                    }}
                />
                <Geom type="line" position="year*人数" size={2} />
                <Geom
                    type="point"
                    position="year*人数"
                    size={4}
                    shape={"circle"}
                    style={{
                      stroke: "#fff",
                      lineWidth: 1
                    }}
                />
              </Chart>
            </Card>
          </div>
          <div style={{ marginTop: "15px" }}>
          <Row>
            <Col span={13}>
              <Card title="人数分布">
                <Chart height={300} data={this.data} scale={this.cols} padding={[10, 0, 30, 35]} forceFit>
                  <Axis name="classes"/>
                  <Axis name="count" title/>
                  <Tooltip/>
                  <Geom type="interval" position="classes*count"/>
                </Chart>
              </Card>
            </Col>
            <Col span={10} offset={1}>
              <Card title="来源渠道">
                <Chart
                    height={300}
                    data={this.dv}
                    scale={this.cols2}
                    padding={[0, 0, -40, 50]}
                    forceFit
                >
                  <Coord type={"theta"} radius={0.75} innerRadius={0.6}/>
                  <Axis name="percent"/>
                  <Tooltip showTitle={false}/>
                  <Guide>
                    <Guide.Html
                        position={["50%", "50%"]}
                        html="<div style=&quot;color:#8c8c8c;font-size:1.16em;text-align: center;width: 10em;&quot;>主机<br><span style=&quot;color:#262626;font-size:2.5em&quot;>32</span>台</div>"
                        alignX="middle"
                        alignY="middle"
                    />
                  </Guide>
                  <Geom
                      type="intervalStack"
                      position="percent"
                      color="item"
                      tooltip={[
                        "item*percent",
                        (item, percent) => {
                          percent = percent * 100 + "%";
                          return {
                            name: item,
                            value: percent
                          };
                        }
                      ]}
                      style={{lineWidth: 1, stroke: "#fff"}}>
                    <Label
                        content="percent"
                        formatter={(val, item) => {
                          return item.point.item + ": " + val;
                        }}
                    />
                  </Geom>
                </Chart>
              </Card>
            </Col>
          </Row>
          </div>
        </React.Fragment>
    )
  }
}

export default HomeIndex
